setObservable